import AbstractType from "./AbstractType";

class BoolType extends AbstractType
{
    static type = "bool";

    test = (value) => typeof value === "boolean";
};

export default BoolType;